export const GET_DRAFT_QUESTIONS = 'GET_DRAFT_QUESTIONS';
export const GET_MORE_DRAFT_QUESTIONS = 'GET_MORE_DRAFT_QUESTIONS';
export const FAIL_GET_DRAFT_QUESTIONS = 'FAIL_GET_DRAFT_QUESTIONS';
export const REQUEST_GET_DRAFT_QUESTIONS = 'REQUEST_GET_DRAFT_QUESTIONS';
export const REQUEST_GET_MORE_DRAFT_QUESTIONS =
  'REQUEST_GET_MORE_DRAFT_QUESTIONS';
export const REQUEST_DELETE_DRAFT_QUESTION = 'REQUEST_DELETE_DRAFT_QUESTION';
export const DELETE_DRAFT_QUESTION = 'DELETE_DRAFT_QUESTION';
